import { useState } from "react";
import VisitorList from "../VisitorsList";
import AddVisitor from "../AddVisitor";
import Modal from "@/common/elements/Modal";
import { StyledSectionHeading } from "@/common/styles";

const VisitorLogDetails = ({startingPoint}) => {
  const [showAddVisitor, setShowAddVisitor] = useState(false);

  const switchToAddVisitor = () => {
    setShowAddVisitor(!showAddVisitor);
  };

  return (
    <>
      <StyledSectionHeading marginTop="0px">
        <span>List of Visitors for the inmate</span>
      </StyledSectionHeading>

      <VisitorList switchToAddVisitor={switchToAddVisitor} isBookings={true} startingPoint={startingPoint}/>

      <Modal
        header="Add Visitor"
        show={showAddVisitor}
        size="xl"
        onHide={switchToAddVisitor}
      >
        <AddVisitor onHide={switchToAddVisitor} startingPoint={startingPoint}/>
      </Modal>
    </>
  );
};
export default VisitorLogDetails;
